import { css } from '@emotion/react'
import {
  Color,
  Theme,
  FocusIndicator,
  ZIndex,
  wideGamutColor,
} from '@opallabs/gem'

export const selectors = {
  disabled: 'persistent-option--disabled',
}

export const selectOverrides = (theme: Theme) =>
  css({
    '.multi-select-value-input': {
      backgroundColor: Color[theme]['Color/Surface/Surface-1'],

      '.multi-select-value-input-placeholder': {
        display: 'none',
      },

      '&[aria-expanded="false"]': {
        borderColor: 'transparent',

        '.multi-select-value-input-placeholder': {
          color: Color[theme]['Text/Secondary'],
          display: 'inline',
        },

        '&:hover': {
          backgroundColor: Color[theme]['Color/Surface/Surface-2'],
        },
      },

      '&:focus-visible, &:focus': {
        ...FocusIndicator[theme],
      },
    },

    '> div': {
      zIndex: ZIndex.Element.Level2,
    },

    '.multi-check-select__persistent-option': {
      borderBlockStart: `1px solid ${wideGamutColor(Color[theme]['Strokes/Secondary-4'], 0.08)}`,
    },
  })

export const persistentOption = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [`&.${selectors.disabled}`]: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
})
